<div class="gpd-full-page" style="overflow-y: auto !important;">
  <router-outlet></router-outlet>
</div>
